/**
 * DS-owned map-stage frame heights (px), keyed by semantic density name.
 *
 * A Leaflet-backed stage (FmStandMap → PropertyForestMap) needs a concrete px
 * number, not a CSS token, so the number lives HERE in the primitive layer —
 * route code requests `size="workspace"` and never holds a magic px constant.
 * Kept in its own module (not a component file) so it can be shared by
 * FmMapStage + FmStandMap without tripping react-refresh's component-only export.
 */
export const FM_MAP_STAGE_SIZE_PX = {
  /** Supporting spatial evidence inside a report chapter. */
  report: 360,
  /** Sale-scope / definer workspace stage (leimikko map). */
  workspace: 480,
} as const;

export type FmMapStageSize = keyof typeof FM_MAP_STAGE_SIZE_PX;
